import { render } from "./외과.vue?vue&type=template&id=efd1bf82"
import script from "./외과.vue?vue&type=script&lang=js"
export * from "./외과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__